import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { KeycloakCredentialsService } from '../../services/keycloak-credentials.service';

@Directive({
  selector: '[allowTo]',
  standalone: true,
})
export class AllowToDirective {
  hasCreated = false;

  constructor(private templateRef: TemplateRef<unknown>, private viewContainer: ViewContainerRef, private credentials: KeycloakCredentialsService) { }

  @Input()
  set allowTo(roles: Array<Array<string>> | Array<string>) {
    const hasRole = this.hasRole(roles);

    if (!hasRole) {
      this.viewContainer.clear();
      return;
    }

    if (!this.hasCreated) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasCreated = true;
    }
  }

  private hasRole(roles: Array<Array<string>> | Array<string> = []) {
    if (!roles.length) {
      return true;
    }

    console.log('Checking roles', roles);

    if (typeof roles[0] === 'string') {
      return (roles as Array<string>).some((role) => this.credentials.roles?.includes(role));
    }

    return (roles as Array<Array<string>>).some((group) => group.every((role) => this.credentials.roles?.includes(role)));
  }
}
